


















































import {Component, Emit, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
const loader = namespace('loader');
const blog = namespace('blog');

@Component
export default class OlderPost extends Vue {
  private page = 1;

  @blog.State
  private found!: number;

  @loader.State
  private loading!: boolean;

  @Emit()
  incrementPage(): number {
    this.page += 1;
    return this.page;
  }
}
